import styled from 'styled-components';
import Icon from '../../components/atoms/Icon';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5vw;
`;

export const IconButton = styled(Icon)`
  margin-bottom: 15px;
  margin-right: 15px;
  &:active {
    opacity: 0.8;
  }
`;
